// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3Cfrv","text":"SelectPayment_text__3pD3Y","title":"SelectPayment_title__3xNOj","btn":"SelectPayment_btn__eGXF6"};